(function ($) {
  'use strict';

  this.CyclingTrips.Archive = function () {
    this.init = function () {
      CTAMap.ini();
      GLSearch.init();
    };

    if (document.placesApiLoaded) {
      this.init();
    } else {
      $(document).on('placesApiLoaded', this.init.bind(this));
    }
  };
}).bind(window)(jQuery);

var CTAMap = {};
CTAMap.ini = function () {
  CTAMap.map.ini();
  CTAMap.view.ini();
  CTAMap.view.numberOfAppliedFilters();

  jQuery(document).on('click', '.location-form-target svg', function (e) {
    e.preventDefault();
    CTAMap.map.setCurrentLocation();
  });

  jQuery(document).on('click', '.location-search-submit', function (e) {
    e.preventDefault();

    setTimeout(function () {
      if (!GLSearch.isSelected()) {
        var currentLatLng = CTAMap.map.obj.getCenter();
        GLSearch.setCoordinates(currentLatLng.lat(), currentLatLng.lng());
        GLSearch.getInput().val('');
      }

      CTAMap.place.getDetails(function (result) {
        CTAMap.api.clearArgs();
        CTAMap.api.setArgsFromForm();

        if (typeof result.place !== 'undefined') {
          CTAMap.queue.disableUntilMapIdle();
          CTAMap.map.setCurrentMarker(
            result.place.geometry.location.lat(),
            result.place.geometry.location.lng()
          );
          CTAMap.map.obj.setCenter({
            lat: result.place.geometry.location.lat(),
            lng: result.place.geometry.location.lng(),
          });
          CTAMap.map.obj.fitBounds(result.place.geometry.viewport);
          CTAMap.api.setArgsFromPlace();
        } else {
          CTAMap.map.obj.setCenter({
            lat: result.coordinates.lat,
            lng: result.coordinates.lng,
          });
          CTAMap.api.setArgsFromLatLng();
        }

        CTAMap.queue.start();
      });
    }, 200);
  });

  CTAMap.api.setArgsFromUrlAndExecute();
};

if (typeof Object.assign !== 'function') {
  Object.assign = function (target) {
    'use strict';
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    target = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var source = arguments[index];
      if (source != null) {
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
    }
    return target;
  };
}
